module.exports = __webpack_public_path__ + "calendar.b11dc4fe59e36a57deebe96322cef4f1.png";